<template>
  <div class="programDetail">
    <mt-header fixed title="">
      <div slot="left">
        <!-- <span @click="goBack" class="backSpan"><img src="../assets/imgs/backIcon.png" alt=""></span> -->
        <mt-button router-link="'/'">培训计划详情</mt-button>
      </div>
      <!-- <div slot="right"  @click="ShouPup">
        <input class="text-hui" v-model="mes"  readonly />
        <i class="mint-cell-allow-bottom" v-show="isChangeDate"></i>
      </div> -->
    </mt-header>
    <!-- <div  v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="5"> -->
      <div class="detailIitem"  v-for="(item,index) in list" :key="index" v-if="isHasdata">
        <div class="programTit">
          <div class="itemTit">{{item.title}}</div>
          <i class="mint-cell-allow-right"  v-on:click="showPhotos(item.nodes_id)">学习照片</i>
        </div>
        <div class="videoDiv" @click="toStudy(item)">
          <img :src="baseUrl + item.image_path" alt="">
          <div class="mask">
            <!-- <span class="pici">批次{{item.study_type !== null?item.study_type:1}}</!-->
            <img src="../assets/imgs/toPlay.png" alt="">
            <p v-if="item.play_point === 0 || item.play_point === null">未学</p>
            <p v-else-if="Math.floor(Number(item.played_progress))=== 100">已学</p>
            <p v-else>{{item.played_progress}}</p>
          </div>
        </div>
      </div>
      <div v-if="!isHasdata" class="noData">
        <img src="../assets/imgs/noDate.png" alt="">
        <p>暂无数据</p>
      </div>
    <!-- 学习照片---start -->
    <mt-popup v-model="popupVisible" position="bottom" class="popupDiv">
      <div class="studyPhotos">
        <ul>
          <li  v-for="item in photoList" :key="item.id">
            <img :src="item.image" alt="" />
          </li>
        </ul>
      </div>
    </mt-popup>
    <!-- 学习照片---end -->

  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import {  photoLists, videoPlNotesHome,  isPayFee } from '../../src/api/Api'
export default {
  name: 'programDetail',
  data () {
    return {
      list: [],
      photoList: [],
      loading: false,
      popupVisible: false,
      showToolbar: true,
      mes: this.$route.query.sMonth,
      pickDatas: [],
      ispopupVisible: false,
      isHasdata: true,
      fromW: this.$route.query.fromW,
      isChangeDate: false,
      player: '',
      options: {},
      pickCheckedVal: '',
      eId: Number(this.$route.query.eid),
      hpid: Number(this.$route.query.pid),
      hcid: this.$route.query.cid,
      baseUrl: window.baseapi.baseUrl
    }
  },
  computed: {
    slots () {
      console.log('slots~~~~~~')
      let allData = [
        {
          values: this.pickDatas
        }
      ]
      return allData
    }
  },
  created () {
    this.GetvideoPlayNotes()
  },
  methods: {
    goBack: function () {
      history.back()
    },
    ShouPup () {
      if (this.fromW === 'list') {
        this.ispopupVisible = true
      }
    },
    GetvideoPlayNotes () {
      console.log('进方法了！！')
      var _this = this
      console.log(_this.$route.query.sMonth + '*************' + _this.$route.query.eid + '###' + _this.$route.query.pid)

      if (this.fromW === 'home') {
        console.log('from---home')
        _this.isChangeDate = false
        videoPlNotesHome({
          'employeeId': _this.eId,
          'professionId': sessionStorage.getItem('professionId'),
          'studyMonth': _this.$route.query.sMonth,
          'companyId': _this.hcid
        }).then(res => {
          if (res.data.code === 200) {
            console.log('查出来有数据' + _this.isHasdata)
            _this.list = res.data.data
            _this.isHasdata = true
          } else {
            console.log('没数据')
            _this.isHasdata = false
          }
        })
      }
    },
    toStudy: function (obj) {
      let _this = this
      // 是否缴费
      isPayFee({
        'employeeId': _this.eId,
        'industryId': sessionStorage.getItem('professionId'),
        'studyMonth': _this.mes,
        'companyId': _this.hcid
      }).then(res => {
        if (res.data.code === 200) { // 缴费了
          var isPhotoPass=sessionStorage.getItem('isPasshoto')
          if(isPhotoPass == 1){//照片也审核通过了，就可以去学了
            let playType = obj.file_path.substring(obj.file_path.lastIndexOf('.') + 1)
            console.log(obj)
            if (playType === 'mp4' || playType === 'flv') {
              this.$router.push({path: '/v', query: { videoObj: obj }})
            } else if (playType === 'pdf') {
              this.$router.push({path: '/pdf', query: { videoObj: obj }})
            }
          }else {
             Toast('未上传图像及审核，暂不能学习视频！')
          }

        } else {
          Toast('您还未缴费，先去首页缴费吧！')
          this.$router.go(-1)
        }
      })
    },
    loadMore () {
      this.loading = true
      setTimeout(() => {
        let last = this.list[this.list.length - 1]
        for (let i = 1; i <= 5; i++) {
          this.list.push(last + i)
        }
        this.loading = false
      }, 500)
    },
    showPhotos (vpId) {
      console.log('vpId::::::::::::' + vpId)
      if (vpId === null || vpId === undefined) {
        Toast('暂无学习照片')
        return
      }
      var _this = this
      photoLists({
        'employeeId': _this.eId,
        'videoPlanNoteId': vpId
      }).then(res => {
        _this.photoList = res.data.data
        if (res.data.code === 10001) {
          _this.popupVisible = false
          Toast('暂无学习照片')
        } else if (_this.photoList.length > 0 && res.data.code === 200) {
          _this.popupVisible = true
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ProgramDetail.vue